import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Header from '../components/Header/Header'
import Abouthome from '../components/Home/Abouthome'
import PhotoVideo from '../components/Home/PhotoVideo'
import Owner from '../components/Home/Owner'
import Featuredwork from '../components/Home/Featuredwork'
import Reviewone from '../components/Home/Reviewone'
import Whyus from '../components/Home/Whyus'
import Productions from '../components/Home/Productions'
import Review from '../components/Home/Review'
import Footer from '../components/Footer/Footer'
import { section1, section2, section3, section4, section5, section6, section7, section8, section9 } from '../mdx/contents/home.mdx'

const Homepage = () => {
    return (
        <div>
            <Navbar />
            <Header content={section1} />
            <Abouthome content={section2} />
            <PhotoVideo items={section3} />
            <Owner content={section4} />
            <Featuredwork content={section5} />
            <Reviewone content={section6} />
            <Whyus content={section7} />
            <Productions services={section8} />
            <Review content={section9} />
            <Footer />
        </div>
    )
}

export default Homepage

